const useErrors = (errors, name) => !!errors?.[name] ?? false;

export default useErrors;
